/**
 * Ghost mode: spara rekordspelets poängutveckling per omgång och jämför
 * pågående spel mot den ("👻 +12 p före ditt rekord efter omgång 9").
 *
 * En ghost per spelläge (modeId). Sparas automatiskt när ett spel slutförs
 * med nytt rekord för läget. I reverse-lägen är lägre slutpoäng bättre.
 */

export interface GhostGame {
  modeId: string;
  /** Kumulativ totalpoäng efter varje omgång (inkl. ev. bonus vid den punkten). */
  totals: number[];
  finalScore: number;
  date: string; // YYYY-MM-DD
}

const keyFor = (modeId: string) => `yatzy-ghost:${modeId}`;

export function loadGhost(modeId: string): GhostGame | null {
  try {
    const raw = localStorage.getItem(keyFor(modeId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as GhostGame;
    if (!parsed || !Array.isArray(parsed.totals) || typeof parsed.finalScore !== 'number') return null;
    return parsed;
  } catch {
    return null;
  }
}

/**
 * Sparar spelet som ny ghost om det slår nuvarande rekord för läget.
 * Returnerar true om en ny ghost sparades.
 */
export function maybeSaveGhost(
  modeId: string,
  totals: number[],
  finalScore: number,
  lowerIsBetter = false
): boolean {
  if (!totals.length) return false;
  const existing = loadGhost(modeId);
  const isBetter = !existing || (lowerIsBetter ? finalScore < existing.finalScore : finalScore > existing.finalScore);
  if (!isBetter) return false;
  try {
    const ghost: GhostGame = {
      modeId,
      totals,
      finalScore,
      date: new Date().toISOString().slice(0, 10),
    };
    localStorage.setItem(keyFor(modeId), JSON.stringify(ghost));
    return true;
  } catch {
    return false;
  }
}
